import { Injectable } from '@angular/core';
import { ApplicationRetrievalPayload } from '../interfaces/request-payloads.interface';
import {
  HTTPWrapperContext,
  RequestConfigImplementation,
  REQUEST_METHODS,
  XHR_STRATEGIES
} from '@ptl/xhr';
import { HttpHeaders } from '@angular/common/http';
import { ApplicationStatusItem } from '../interfaces/response-payloads.interface';
import { ZipCountyStateStructure } from 'src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PreLoginAppStatusService {
  constructor(
    private httpClient: HTTPWrapperContext,
    private reducerUtilityService: ReducerUtilityService,
  ) { }



  encodeDdtoken(ddToken): string {
    return btoa(ddToken);
  }

  getStatus(
    payload: ApplicationRetrievalPayload
  ): Promise<ApplicationStatusItem> {
    const zipcountyState: ZipCountyStateStructure = this.reducerUtilityService.getState(
      'ZipCounty'
    );


    const requestConfigImplementation = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      url: '/sxesvc/api/v1/retailapp/checkstatus',
      headers: new HttpHeaders({
        ddToken: this.encodeDdtoken(environment.initData.brand.ddToken)

      }),
      POST_OR_PUT_PAYLOAD: payload
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_PRE_PASS);
    this.httpClient.disableErrorSnackbar(requestConfigImplementation);
    return this.httpClient.makeRequest<ApplicationStatusItem>(
      requestConfigImplementation
    );
  }
}
